<template>
  <div
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #f7f8fa; /* 或者使用背景图片 background-image: url('path/to/image.jpg'); */
      z-index: -1;
    "
  >
    <div>
      <div
        style="
          margin-left: 20px;
          text-align: start;
          font-size: 18px;
          font-weight: 500;
          margin-top: 30px;
        "
      >
        输入信息查询
      </div>
      <div
        style="
          background-color: #fff;
          border-radius: 4px;
          margin: 10px;
          padding: 10px;
        "
      >
        <div
          style="
            display: flex;
            border-bottom: 1px solid #ccc;
            align-items: center;
          "
        >
          <!-- <div style="font-size: 16px; line-height: 50px"></div> -->
          <div style="font-size: 16px; padding: 10px 0">
            <van-radio-group v-model="flag" direction="horizontal">
              <van-radio name="1">停车订单</van-radio>
              <van-radio name="2">包月订单</van-radio>
              <van-radio name="3">企业订单</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div
          v-show="flag != 3"
          style="display: flex; border-bottom: 1px solid #ccc"
        >
          <span style="font-size: 16px; line-height: 50px">车牌号码</span>
          <input
            style="
              width: 70%;
              line-height: 50px;
              border: none;
              text-indent: 7px;
              font-size: 18px;
            "
            type="text"
            placeholder="需要查询的车牌号码"
            placeholder-style="font-size:13px"
            v-model="carNumber"
          />
        </div>

        <div
          v-show="flag == 3"
          style="
            display: flex;
            border-bottom: 1px solid #ccc;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          <span style="font-size: 16px; line-height: 50px">所属公司</span>
          <span
            @click="isShowPicker = !isShowPicker"
            style="
              font-size: 16px;
              line-height: 50px;
              margin-left: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 210px;
            "
            >{{ pickerName }}</span
          >
        </div>
        <!-- <div style="display: flex">
          <span style="font-size: 16px; line-height: 50px">商户单号</span>
          <input
            style="
              text-transform: uppercase;
              width: 70%;
              line-height: 50px;
              border: none;
              text-indent: 7px;
              font-size: 18px;
            "
            type="text"
            placeholder="商户单号(后六位)"
            v-model="orderNo"
          />
        </div>
        <div style="color: #f53f3f; font-size: 12px; margin-top: 5px">
          注：商户单号只填写停车缴费支付记录中商户单号的后六位
        </div> -->
      </div>
      <div
        style="
          width: 100;
          text-align: center;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <button
          v-if="flag != 3"
          style="
            background: #4088ff;
            width: 90%;
            border: none;
            color: #fff;
            line-height: 40px;
            font-size: 16px;
            border-radius: 26px;
          "
          @click="getList"
        >
          查询
        </button>
        <button
          v-else
          style="
            background: #4088ff;
            width: 90%;
            border: none;
            color: #fff;
            line-height: 40px;
            font-size: 16px;
            border-radius: 26px;
          "
          @click="companyMonthList"
        >
          查询
        </button>
      </div>
    </div>

    <van-popup
      v-model="isShowPicker"
      :close-on-click-overlay="false"
      :safe-area-inset-bottom="true"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="date_confirm">
        <van-search
          style="width: 100%"
          v-model="comvalue"
          :clearable="false"
          placeholder="请输入搜索关键词"
          @input="funcCompanyList"
        />
      </div>
      <van-picker
        v-show="isShowPicker"
        show-toolbar
        :columns="companyInfoList"
        @confirm="onConfirm"
        @cancel="isShowPicker = false"
      />
    </van-popup>

    <div v-if="orderList.length > 0">
      <div
        style="
          margin-left: 20px;
          text-align: start;
          font-size: 18px;
          font-weight: 500;
        "
      >
        选择停车订单开票
      </div>
      <!-- 企业包月 -->
      <div
        v-if="flag == 3"
        style="padding: 0 20px; height: 480px; overflow-y: scroll"
      >
        <ul style="padding-bottom: 200px">
          <li
            v-for="order in orderList"
            :key="order.ID"
            style="
              display: flex;
              background-color: #fff;
              margin-top: 10px;
              padding: 15px;
            "
          >
            <input
              type="checkbox"
              :value="order"
              v-model="selectedOrders"
              :checked="true"
              @change="handleChange(order)"
            />
            <div style="font-size: 16px; text-align: start">
              <div style="font-size: 13px; color: #4e5969; line-height: 26px">
                <van-row>
                  <van-col span="8">订单编号：</van-col>
                  <van-col span="16">{{ order.code }}</van-col>
                </van-row>
                <!-- <span>订单编号：</span><span>{{ order.code }}</span> -->
              </div>
              <div style="line-height: 26px">
                <van-row>
                  <van-col span="8">企业名称：</van-col>
                  <van-col span="16">{{ order.parkCompanyName }}</van-col>
                </van-row>
                <!-- <span>企业名称：</span><span>{{ order.parkCompanyName }}</span> -->
              </div>
              <div style="line-height: 26px">
                <van-row>
                  <van-col span="8">包月数量：</van-col>
                  <van-col span="16">{{ order.monthlyDuration }}</van-col>
                </van-row>
                <!-- <span>包月数量：</span><span>{{ order.monthlyDuration }}</span> -->
              </div>
              <div style="line-height: 26px">
                <van-row>
                  <van-col span="8">包月时间：</van-col>
                  <van-col span="16">{{ order.parkCompanySelectDate }}</van-col>
                </van-row>
                <!-- <span>包月时间：</span
                ><span>{{ order.parkCompanySelectDate }}</span> -->
              </div>
              <div style="line-height: 26px">
                <van-row>
                  <van-col span="8">总计：</van-col>
                  <van-col span="16"
                    ><span
                      style="font-size: 18px; color: #f97a07; font-weight: 500"
                      >{{ order.actualToll / 100 }}元</span
                    ></van-col
                  >
                </van-row>
                <!-- <span>总计：</span
                ><span style="font-size: 18px; color: #f97a07; font-weight: 500"
                  >{{ order.actualToll / 100 }}元</span
                > -->
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div v-else style="padding: 0 20px; height: 480px; overflow-y: scroll">
        <ul style="padding-bottom: 200px">
          <li
            v-for="order in orderList"
            :key="order.ID"
            style="
              display: flex;
              background-color: #fff;
              margin-top: 10px;
              padding: 15px;
            "
          >
            <input
              type="checkbox"
              :value="order"
              v-model="selectedOrders"
              :checked="true"
              @change="handleChange(order)"
            />
            <div style="font-size: 16px; text-align: start">
              <div style="font-size: 13px; color: #4e5969; line-height: 26px">
                <van-row>
                  <van-col span="8">订单编号：</van-col>
                  <van-col span="16">{{ order.code }}</van-col>
                </van-row>
                <!-- <span>订单编号：</span><span>{{ order.code }}</span> -->
              </div>
              <div style="line-height: 26px; font-size: 14px">
                <van-row>
                  <van-col span="8">车场名称：</van-col>
                  <van-col span="16">{{ order.parkName }}</van-col>
                </van-row>
                <!-- <span>车场名称：</span><span>{{ order.parkName }}</span> -->
              </div>
              <div style="line-height: 26px; font-size: 14px">
                <van-row>
                  <van-col span="8">车牌号码：</van-col>
                  <van-col span="16">{{ order.carNumber }}</van-col>
                </van-row>
                <!-- <span>车牌号码：</span><span>{{ order.carNumber }}</span> -->
              </div>
              <div v-if="flag == 2">
                <div style="line-height: 26px; font-size: 14px">
                  <van-row>
                    <van-col span="8">开始时间：</van-col>
                    <van-col span="16">{{ order.startTime }}</van-col>
                  </van-row>
                  <!-- <span>开始时间：</span><span>{{ order.startTime }}</span> -->
                </div>
                <div style="line-height: 26px; font-size: 14px">
                  <van-row>
                    <van-col span="8">结束时间：</van-col>
                    <van-col span="16">{{ order.endTime }}</van-col>
                  </van-row>
                  <!-- <span>结束时间：</span><span>{{ order.endTime }}</span> -->
                </div>
              </div>
              <div v-else>
                <div style="line-height: 26px; font-size: 14px">
                  <van-row>
                    <van-col span="8">入场时间：</van-col>
                    <van-col span="16">{{ order.entryTime }}</van-col>
                  </van-row>
                  <!-- <span>入场时间：</span><span>{{ order.entryTime }}</span> -->
                </div>
                <div style="line-height: 26px; font-size: 14px">
                  <van-row>
                    <van-col span="8">出场时间：</van-col>
                    <van-col span="16">{{ order.exitTime }}</van-col>
                  </van-row>
                  <!-- <span>出场时间：</span><span>{{ order.exitTime }}</span> -->
                </div>
              </div>
              <div style="line-height: 26px; font-size: 14px" v-if="flag == 2">
                <van-row>
                  <van-col span="8">包月时间：</van-col>
                  <van-col span="16">{{ order.monthlyDuration }}</van-col>
                </van-row>
                <!-- <span>包月时间：</span><span>{{ order.monthlyDuration }}</span> -->
              </div>
              <div style="line-height: 26px; font-size: 14px" v-else>
                <van-row>
                  <van-col span="8">停放时长：</van-col>
                  <van-col span="16">{{ order.parkDuration }}</van-col>
                </van-row>
                <!-- <span>停放时长：</span><span>{{ order.parkDuration }}</span> -->
              </div>
              <div style="line-height: 26px; font-size: 14px">
                <van-row>
                  <van-col span="8"
                    ><span style="text-align-last: justify"
                      >金额总计：</span
                    ></van-col
                  >
                  <van-col span="16"
                    ><span
                      style="font-size: 18px; color: #f97a07; font-weight: 500"
                      >{{ order.actualToll / 100 }}元</span
                    ></van-col
                  >
                </van-row>
                <!-- <span>总计：</span
                ><span style="font-size: 18px; color: #f97a07; font-weight: 500"
                  >{{ order.actualToll / 100 }}元</span
                > -->
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div
      style="
        display: flex;
        justify-content: flex-end;
        font-size: 14px;
        background-color: #fff;
        width: 100%;
        height: 60px;
        line-height: 60px;
        position: fixed;
        bottom: 0;
      "
    >
      <!-- <div style="margin-left: 20px">
        <input type="checkbox" v-model="selectAll" /> 全选
      </div> -->
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-right: 10px;
        "
      >
        <div style="margin-right: 20px">
          <span
            >费用合计：<span style="color: #4088ff; font-weight: 500"
              >￥{{ totalAmount }}</span
            ></span
          >
        </div>
        <div
          v-if="flag == 3"
          style="
            width: 70px;
            height: 40px;
            line-height: 40px;
            background-color: #4088ff;
            color: #fff;
          "
          @click="printSelectedOrdersCompany"
        >
          开票
        </div>
        <div
          v-else
          style="
            width: 70px;
            height: 40px;
            line-height: 40px;
            background-color: #4088ff;
            color: #fff;
          "
          @click="printSelectedOrders"
        >
          开票
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getInvoiceList, submitInvoice, getComapnyInvoiceList, getCompanyInfo, invoiceApplyCompany, doApplyPiaoTongPrivate } from '@/api/invoice'
export default {
  props: {

  },
  name: 'invoiceSearch',
  data () {
    return {
      carNumber: '',
      orderNo: '',
      //   selectAll: false,
      isShowDialog: false,

      isShowPicker: false,

      orderList: [],
      selectedOrders: [],
      carParkId: '',

      flag: '1', // 1 临停 2 包月 3 企业

      orderId: '',
      ThirdOrderNo: '',

      formData: {},

      companyList: [],
      companyInfoList: [],
      pickerIndex: 0,

      comvalue: '',
      pickerName: '请选择',
      // 筛选后的公司数据
      filterCompanyList: [],

      infoiceType: ''//包月类型 piaotong  nuonuo
    };
  },
  components: {

  },
  destroyed () {
    Toast.clear()
  },
  computed: {
    totalAmount () {
      return this.selectedOrders.reduce((total, order) => total + order.actualToll / 100, 0);
    }
  },
  watch: {
    // selectAll: function (value) {
    //   if (value) {
    //     this.selectedOrders = this.orderList.slice();
    //   } else {
    //     this.selectedOrders = [];
    //   }
    // },
    flag: function (value) {
      this.orderList = []
      this.selectedOrders = [];
    }
  },
  created () {
    this.formData = this.$route.params
    this.carParkId = this.$route.params.carParkId
    this.getInvoiceCompany()
  },
  mounted () {

  },
  methods: {
    // 封装筛选逻辑
    funcCompanyList (e) {
      this.filterCompanyList = this.companyList.filter(person => person.parkCompanyName.includes(e));
      this.companyInfoList = this.filterCompanyList.map(item => {
        return item.parkCompanyName
      })
    },

    async getInvoiceCompany () {
      const { data } = await getCompanyInfo({
        parkId: this.carParkId
      })
      if (data.code == 200) {
        this.companyList = data.data.list
        this.filterCompanyList = data.data.list
        this.companyInfoList = data.data.list.map(item => {
          return item.parkCompanyName
        })
      } else {
        Toast(data.msg)
      }
    },
    onConfirm (value, index) {
      if (value) {
        this.pickerName = value
        this.pickerIndex = index;
        this.isShowPicker = false;
      } else {
        Toast('请选择所属公司')
      }
    },


    handleChange (option) {
      // 如果选择的选项超过5个，移除最后一个选项
      if (this.selectedOrders.length > 5 && this.selectedOrders.includes(option)) {
        this.selectedOrders = this.selectedOrders.filter(item => item !== option); // 取消选中当前选项
        console.log('选中数据', this.selectedOrders);
        alert("最多只能选择5条记录！"); // 可以自定义警告信息或者使用其他方式提示用户
      }
    },
    // 企业开票
    async printSelectedOrdersCompany () {
      if (this.selectedOrders.length === 0) {
        alert('请至少选择一个订单进行开票');
      } else if (this.selectedOrders.length > 1) {
        alert('最多只能选择一个订单进行开票');
      }
      else {
        Toast.loading({
          message: '开票中...',
          forbidClick: true,
          duration: 0
        });
        const arr = []
        // 模拟打印选中订单的逻辑
        if (this.flag == 1) {
          this.selectedOrders.forEach(item => {
            arr.push(item.code)
            this.ThirdOrderNo = item.ThirdOrderNo
          });
        } else {
          this.selectedOrders.forEach(item => {
            arr.push(item.code)
            this.ThirdOrderNo = item.ThirdOrderNo
          });
        }

        this.orderId = arr.join(',')
        this.formData.price = this.totalAmount * 100
        this.formData.MyOrderNo = this.selectedOrders[0].ThirdPayNo
        this.formData.IDList = this.orderId

        const param = {
          parkId: this.formData.carParkId,
          code: this.formData.IDList,
          buyerName: this.formData.buyerName,
          businessType: this.flag,
          buyerPhone: this.formData.buyerPhone,
          email: this.formData.email,
          buyerTaxNum: this.formData.buyerTaxNum,
          buyerTel: this.formData.buyerTel,
          buyerAddress: this.formData.buyerAddress,
          modelType: this.formData.Type,
          invoiceLine: this.formData.invoiceLine
        }
        const { data } = await invoiceApplyCompany(param)
        Toast.clear()
        if (data.code == 200) {
          Toast(data.msg)
          this.orderList = []
          this.selectedOrders = [];

        } else {
          Toast(data.msg)

        }
      }
    },
    // 个人开票
    async printSelectedOrders () {
      if (this.selectedOrders.length === 0) {
        alert('请至少选择一个订单进行打印');
      } else {
        Toast.loading({
          message: '开票中...',
          forbidClick: true,
          duration: 0
        });
        const arr = []
        // 模拟打印选中订单的逻辑
        if (this.flag == 1) {
          this.selectedOrders.forEach(item => {
            arr.push(item.code)
            this.ThirdOrderNo = item.ThirdOrderNo
          });
        } else {
          this.selectedOrders.forEach(item => {
            arr.push(item.code)
            this.ThirdOrderNo = item.ThirdOrderNo
          });
        }

        this.orderId = arr.join(',')
        this.formData.price = this.totalAmount * 100
        this.formData.MyOrderNo = this.selectedOrders[0].ThirdPayNo
        this.formData.IDList = this.orderId

        const param = {
          parkId: this.formData.carParkId,
          carNumber: this.carNumber,
          code: this.formData.IDList,
          buyerName: this.formData.buyerName,
          businessType: this.flag,
          buyerPhone: this.formData.buyerPhone,
          email: this.formData.email,
          buyerTaxNum: this.formData.buyerTaxNum,
          buyerTel: this.formData.buyerTel,
          buyerAddress: this.formData.buyerAddress,
          modelType: this.formData.Type,
          invoiceLine: this.formData.invoiceLine
        }
        if (this.infoiceType == 'piaotong') {
          const { data } = await doApplyPiaoTongPrivate(param)
          if (data.code == 200) {
            this.orderList = []
            this.selectedOrders = [];
            Toast.clear()
            Toast(data.msg)
          } else {
            Toast.clear()
            Toast(data.msg)
          }
        } else {
          const { data } = await submitInvoice(param)
          if (data.code == 200) {
            this.orderList = []
            this.selectedOrders = [];
            Toast.clear()
            Toast(data.msg)
          } else {
            Toast.clear()
            Toast(data.msg)
          }
        }
      }
    },
    calculateTotalAmount () {
      let totalAmount = 0;
      this.selectedOrders.forEach(order => {
        totalAmount += order.amount;
      });
      return totalAmount;
    },

    async getList () {
      this.orderList = []
      this.selectedOrders = [];
      Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 0
      });
      if (this.carNumber) {
        // const param = new URLSearchParams()
        // param.append('businessType', this.flag)
        // param.append('carNumber', this.carNumber)
        // // param.append('ThirdOrderNo', this.orderNo)
        // param.append('parkId', this.carParkId)
        const { data } = await getInvoiceList({
          businessType: this.flag,
          carNumber: this.carNumber,
          parkId: this.carParkId
        })
        if (data.code == 200) {
          Toast.clear()
          this.orderList = data.data
          this.infoiceType = data.requestType
        } else {
          Toast(data.msg)
        }
      } else {
        Toast('请填写完整的信息进行查询')
      }
    },


    // 公司订单包月列表
    async companyMonthList () {
      Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 0
      });
      const { data } = await getComapnyInvoiceList({
        parkCompanyCode: this.filterCompanyList[this.pickerIndex].parkCompanyCode,
        // parkCompanyCode: this.companyList[this.pickerIndex].parkCompanyCode,
        monthlyMain: 2,
        parkId: this.carParkId,
        currentPage: 1,
        pageSize: 50
      })
      if (data.code == 200) {
        Toast.clear()
        this.orderList = data.data
      }
    }
  },
};
</script>

<style scoped lang="less">
body {
  background: #f7f8fa;
}
.form-label {
  margin-bottom: 5px;
  font-size: 16px;
}
.btn {
  width: 73px;
  height: 28px;
  line-height: 28px;
  border-radius: 26px;
  border: 1px solid #86909c;
}
.date_confirm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  position: absolute;
  left: 20%;
}
</style>
